import React, { FunctionComponent } from "react";
import { Checkmark, PrimaryButton } from "bb.lego-ui";
import styles from "./styles.module.scss";

export interface StandaloneSuccessProps {
    bloombergSiteUrl: string;
}

const StandaloneSuccess: FunctionComponent<StandaloneSuccessProps> = ({ bloombergSiteUrl }) => {
    return (
        <main>
            <div className={ styles.container }>
                <div className={ styles.success } selectid="newsletter-success-page">
                    <Checkmark color="green" size="large" />
                    <h2>You're Signed Up!</h2>
                    <p>Keep an eye on your inbox.</p>
                    <div className={ styles.submit }>
                        <PrimaryButton type="button" fullWidth={ true } href={ bloombergSiteUrl } target="_parent">
                            Continue to Bloomberg.com
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default StandaloneSuccess;
